import { Input } from '@/ui/core/input'
import { Rise } from '@/ui/core/motion'
import { StepLayout } from '../StepLayout'
import { canProceed, getQuestionState, resolveButtonLabel } from '../logic/stepState'
import { PrimaryStepButton } from './PrimaryStepButton'
import type { StepProps } from './types'

export const QuestionStep = ({
	step,
	state,
	onChange,
	onNext,
	onBack,
	onClose,
	progress,
	isSubmitting,
}: StepProps<string>) => {
	const value = getQuestionState(state)

	return (
		<StepLayout
			title={step.title}
			description={step.description}
			progress={progress}
			onBack={onBack}
			onClose={onClose}
			cta={
				<PrimaryStepButton
					label={resolveButtonLabel(step, value)}
					onPress={onNext}
					disabled={!canProceed(step, value)}
					isLoading={isSubmitting}
				/>
			}
		>
			<Rise>
				<Input
					value={value}
					onChangeText={onChange}
					placeholder={step.inputLabel ?? 'Type your answer'}
					autoCapitalize="sentences"
					returnKeyType="done"
					onSubmitEditing={() => canProceed(step, value) && onNext()}
				/>
			</Rise>
		</StepLayout>
	)
}
